import type { Resource } from '../../';
export const product_details_sizeSelectedMsg: Resource = {"default":"Selected US Size:"};
